import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const InfoManual = `
　被共済職員期間（前勤務先での勤務期間）を合算するためには表示されている期間までに<
　再び次の共済契約者に雇用され、被共済職員となる必要があります。<
　再就職した際は、表示されている引継ぎコードを再就職先の担当者へ伝えてください。<
　なお、期限までに再就職が出来ない場合は、退職手当金を請求してください。`;

const InfoManualOther = `　※引継ぎコードは必ずお控えください（画面のスクリーンショットなどを行ってください）。`;

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "staff",
    type: "text",
    showLine: false,
  },
  {
    title: "合算期限",
    keyword: "limitationDate",
    type: "text",
  },
  {
    title: "退職者識別コード（引継ぎコード）",
    keyword: "transferCd",
    type: "text",
  },
];

export { InfoManual, InfoManualOther, fakeTableList };
